module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-sound_on@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-sound_on@3x.png
// module id = 658
// module chunks = 0